import { BaseButton, IGroup, MessageBarType } from '@fluentui/react';
import { ReactNode } from 'react';

import { App } from '../ai.h2o.cloud.appstore';

export const ALL_CATEGORY = 'ALL',
  OTHER_CATEGORY = 'OTHER',
  MOST_POPULAR = 'Most Popular',
  PINNED_APPS = 'Pinned Apps',
  ALL_APPS = 'All Apps';

export const minute = 60000,
  hour = minute * 60,
  day = hour * 24,
  week = day * 7,
  month = day * 30,
  year = day * 365;

export const IN_A_FEW_MOMENTS = 'in a few moments';

export interface Banner {
  actions?: JSX.Element;
  groupId?: string;
  id: string;
  message: ReactNode;
  messageBarType?: MessageBarType;
  onDismiss?: (ev?: React.MouseEvent<HTMLElement | BaseButton>) => any;
  subTitle?: string;
  title?: string;
}

export type BannerAction =
  | {
      type: `Add`;
      payload: Banner;
    }
  | {
      type: `Remove`;
      payload: { id: string };
    };

export enum InstanceListType {
  admin = 'admin',
  my = 'my',
  app = 'app',
}

export type ClassNamesFromIStyles<IStyles extends object> = {
  [P in keyof IStyles]: string;
};

export interface AppGroupData {
  latestApp: App;
  apps: App[];
  tags: any[];
}

export interface AppGroup extends IGroup {
  data: AppGroupData;
}

export interface AppGroupExtended extends AppGroup {
  editing: boolean;
  deleting: boolean;
}

export type AnyFunction = (...args: any) => any;
